module.exports = __webpack_public_path__ + "img/inspiration-5@2x.e16992a.jpg";